module.exports = __webpack_public_path__ + "static/img/xj_img9.ddd1325.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xj_img9.jpg
// module id = 6kQP
// module chunks = 4